import React from 'react';

function Hero({ scrollY }) {
  const heroTransform = `translateY(${scrollY * 0.5}px)`;

  return (
    <section className="hero" style={{ transform: heroTransform }}>
      <div className="hero-logo-container">
        <img 
          src="/images/logo/logotransparente.png" 
          alt="Sanro" 
          className="hero-logo"
        />
      </div>
      <button className="hero-shop-button" onClick={() => window.location.hash = 'shop'}>Tienda</button>
    </section>
  );
}

export default Hero;
